<template>
  <el-row id="container">
      <el-col :span="24" style="border-bottom: 3px solid #4386CC; background: url('/static/chengshi.png'); background-size: 100% 100%;">
        <div id="header-container">
          <el-row>
            <el-col :span="24" style="height: 134px;">
              <el-row>
                <el-col :span="18">
                  <el-row style="padding-top: 20px;">
                    <el-col :span="2">
                      <img src="/static/CSDRI-logo.png" style="width: 63px; height:63px; float:left; margin-top: 15px;"/>
                    </el-col>
                    <el-col :span="22" style="padding-left: 25px;">
                      <div style="height: 70px; width: 719px; font-size: 49px; color: #CC3300; text-align: left; letter-spacing: 4px;"><b>冶金工业经济发展研究中心</b></div>
                      <!-- <div style="height: 27px; width: 719px; font-size: 23px; color: #000000; text-align: left; font-family: Bodoni Bd BT;"><b>CHINA STEEL DEVELOPMENT & RESEARCH INSTITUTE</b></div> -->
                      <div style="text-align: left;"><img style="height: 22px; width: 630px;" src="/static/yingwen.png"></div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6" style="padding-top: 50px;">
                  <div style="position: relative;">
                    <el-button @click="handleSearch()" style="position: absolute; right:-1px; z-index: 2; background: #4386CC; color: #FFFFFF;" icon="el-icon-search" circle></el-button>
                    <el-input placeholder="输入关键词搜索" v-model="keyword" class="search" style="float: right; z-index: 1;"></el-input>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row style="height: 54px;">
                 <el-col :span="3"><router-link class="nav-font" to="/"><b>首页</b></router-link></el-col>
                 <el-col :span="3"><router-link class="nav-font" to="/organization"><b>组织机构</b></router-link></el-col>
                 <el-col :span="4"><router-link class="nav-font" to="/research"><b>研究咨询</b></router-link></el-col>
                 <el-col :span="3"><router-link class="nav-font" to="/periodical"><b>期刊出版</b></router-link></el-col>
                 <el-col :span="4"><router-link class="nav-font" to="/inform"><b>新闻中心</b></router-link></el-col>
                 <el-col :span="3"><router-link class="nav-font" to="/party"><b>党的建设</b></router-link></el-col>
                 <el-col :span="4"><router-link class="nav-font" to="/aboutus"><b>关于我们</b></router-link></el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="24">
        <router-view :key="$store.state.btn? new Date().toLocaleString():key"/>
      </el-col>
      <el-col :span="24">
        <div id="footer-container">
          <el-row style="height: 100%;">
            <el-col :span="24" style="background: #FFFFFF; height: 101px; border-radius: 6px; overflow: hidden;">
              <marquee direction="left" behavior="scroll" scrollamount="5" scrolldelay="0" loop="-1" width="95%" height="130" hspace="10" vspace="10" onMouseOut="this.start()" onMouseOver="this.stop()">
                  <!-- <a :href="links.url" target="_blank" v-for="(links, index) in linksList" :key="index" style="margin-left: 2%; margin-top: 12px; float: left">
                    <img :src="links.cover"  width="150" height="75" border="0">
                  </a> -->
                  <table style="margin-top: 12px;">
                    <tr>
                      <td  v-for="(links, index) in linksList" :key="index" style="padding-right:10px;">
                        <a :href="links.url" target="_blank">
                          <img :src="links.cover"  width="150" height="75" border="0">
                        </a>
                      </td>
                    </tr>
                  </table>
                </marquee>
            </el-col>
            <el-col :span="24" style="height: 101px; border-radius: 6px; margin-top: 20px; font-size: 14px;">
              <p><span v-text="'版权所有：' + site.siteName" style="margin-right: 30px;"></span><span v-text="'联系电话：' + site.phone" style="margin-right: 30px;"></span><span v-text="'地 址  ：' + site.address" style="margin-right: 30px;"></span><span v-text="'邮 编  ：' + site.postcode"></span></p>
              <div style="margin-top: 5px;"><img src="/static/jingwang.png"  style="width: 32px; height: 32px; margin-right: 20px; vertical-align:middle;"/><span style="margin-bottom: 10px;" v-text="site.icp"></span></div>
            </el-col>
          </el-row>
        </div>
      </el-col>
  </el-row>
</template>

<script>
import { findSite, findLinksAll } from '@/api/front'
export default {
  data: () => ({
    site: {},
    linksList: [],
    keyword: '',
    btn: false,
    key: 123456
  }),
  created(){
    //获取站点信息
    findSite().then(res => {
      this.site = res.data
    })
    //获取友链信息
    findLinksAll().then(res => {
      this.linksList = res.data
    })
  },
  methods:{
    handleSearch(){
      if(this.keyword != ''){
        // this.$router.push({
        //   path: '/search',
        //   query: {'keyword': this.keyword}
        // })
        this.$store.commit('SET_BTN', true)
        this.$router.push('/search/' + this.keyword)
      }
    }
  }
}
</script>

<style scoped>
#container{
  background: #F5F5F5;
  text-align: center;
}

#header-container{
  margin: auto;
  width: 1250px;
  height: 188px;
}

#footer-container{
  margin: auto;
  width: 1250px;
  height: 151px;
  margin-bottom: 15px;
}

.nav-font{
  color: #993300; 
  font-size: 22px;
  line-height: 54px;
}
</style>

<style>

/**修改el-input默认样式 */
.search .el-input__inner{
  border-radius: 18px;
  width: 220px;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/front/layout.vue